import { css } from '@emotion/css'
import { spacing } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import getThemeColors, { colors } from '../../../themes'
import { hexToRgba } from '../../../themes/helpers'

const styles = {
  mention: css({
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
    padding: shorthandHelper([spacing.small, spacing.default]),
    margin: 0,
    cursor: 'pointer',

    '& > * + *': {
      marginLeft: spacing.small,
    },
  }),

  name: css({
    marginLeft: spacing.small,
    color: colors.grayChateau,
  }),
}

export default styles

export const mentionTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    backgroundColor: hexToRgba(themed.light, 0.3),
  })
}
